import React, { useCallback } from 'react';
import {
	Channel,
	ChannelList,
	DefaultStreamChatGenerics,
	MessageInput,
	MessageList,
	MessageOptions,
	MessageOptionsProps,
	Thread,
	Window,
	useChatContext,
} from 'stream-chat-react';
import 'stream-chat-react/dist/css/index.css';

import { ChannelFilters } from 'stream-chat';

import StoreProvider from '@common/components/StoreProvider';

import DeletedMessage from './DeletedMessage';
import ChannelListHeader from './Header';
import CustomMessage from './Message';
import ChatTitle from './Title';
import { useConfig } from './config';
import { getChatRules } from './config/ChatRules';
import { TranslationProvider } from './context';
import { ChannelListNavButton, ChannelListWrapper } from './styled';
import customSearchFunction from './utils/customSearch';
import useAutoGrowTextarea from './utils/useAutoGrowTextarea';

function ChatMessageOptions(props: MessageOptionsProps) {
	return <MessageOptions {...props} displayReplies={false} />;
}

function ChatModule({ store, showChannelSearch = true, t }: any) {
	useAutoGrowTextarea();
	// @TODO: TS or useStore
	const { channel, client, openMobileNav } = useChatContext();

	const { id: currentUserId } = store.profile;
	const { userId: currentCgUserId } = store.chat;
	const showChatRules = useConfig(getChatRules);

	const currentChatUserId = currentCgUserId ?? currentUserId;
	const filters = {
		$and: [
			!showChatRules
				? {
						$or: [{ type: 'messaging' }, { type: 'channel' }],
					}
				: {
						$and: [{ type: 'messaging' }],
					},
			{
				$or: [
					{ service_ids: { $contains: store.services.current.id } },
					{ service_ids: { $contains: `${store.services.current.id}` } },
				],
			},
			{ members: { $in: [`${currentChatUserId}`] } },
		],
	} as ChannelFilters<DefaultStreamChatGenerics>;

	const showDateSeparator = (channel?.state?.messages || []).some(
		(message) => message.type !== 'deleted',
	);

	const MemoizedMessageDeleted = useCallback(
		(props: any) => <DeletedMessage currentUserId={currentChatUserId} {...props} />,
		[currentChatUserId],
	);

	return (
		<TranslationProvider t={t}>
			<StoreProvider store={store}>
				<ChannelListWrapper>
					<ChatTitle />

					<ChannelListNavButton variant="text" color="primary" onClick={openMobileNav}>
						All chat
					</ChannelListNavButton>
					<ChannelList
						// sort={{ has_unread: -1, type: 1, last_updated: -1 }}
						sort={{ last_updated: -1 }}
						filters={filters}
						options={{ limit: 0 }}
						showChannelSearch={showChannelSearch}
						additionalChannelSearchProps={{
							searchForChannels: true,
							searchFunction: (params, event) =>
								customSearchFunction(params, event, client, currentChatUserId, filters),
						}}
					/>
				</ChannelListWrapper>
				<Channel MessageDeleted={MemoizedMessageDeleted} MessageOptions={ChatMessageOptions}>
					<Window>
						<ChannelListHeader />
						<MessageList Message={CustomMessage} disableDateSeparator={!showDateSeparator} />
						{/* @ts-ignore */}
						{channel?.data?.own_capabilities?.includes('send-message') && <MessageInput />}
					</Window>
					<Thread />
				</Channel>
			</StoreProvider>
		</TranslationProvider>
	);
}

export default ChatModule;
